export enum ModuleTypeEnum {
  Python = 1,
  Regulatory = 2,
}
